<template>
    <canvas-layout>

        <template #header>
            <canvas-header :team="team" />
        </template>

        <div class="student-canvas">
            <stage-tabs :stages="stages"
                        @change="tabChanged($event)"
                        v-model="stage_id"/>
            <stage-title class="px-5" :stages="stages" v-model="stage_id"/>

            <div class="container-fluid mt-2 mb-3">
                <div class="px-5">
                    <div class="row">
                        <div class="col-md-4 px-5">
                            <stage-highlight icon="comment"
                                             title="Introduction"
                                             content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam felis diam, dictum a laoreet porttitor, auctor vel urna. Sed nec egestas eros. Ut varius quam eu interdum vulputate. Ut at sollicitudin nibh. Sed volutpat rhoncus sollicitudin."
                                             :color="active_stage.color" />
                        </div>
                        <div class="col-md-4 px-5">
                            <stage-highlight icon="map"
                                             title="Mission"
                                             content="Ut at sollicitudin nibh. Sed volutpat rhoncus sollicitudin. Aenean congue fermentum dui, a suscipit sapien lacinia eu. Phasellus non mi a nisi venenatis lacinia. Quisque vitae neque in sapien consequat pharetra."
                                             :color="active_stage.color" />
                        </div>
                        <div class="col-md-4 px-5">
                            <stage-highlight icon="play"
                                             title="Video"
                                             content="Suspendisse viverra, turpis eget euismod tincidunt, nisl leo varius ex, id feugiat tortor lacus non arcu. Donec tellus enim, commodo eu massa quis, porta cursus quam. Mauris id rutrum elit. Vivamus pretium nisi eu ullamcorper porttitor."
                                             :color="active_stage.color" />
                        </div>
                    </div>
                </div>
            </div>


            <div class="text-center my-5">
                <go-to-next-section target="#step-2"
                                    :color="active_stage.color"/>
            </div>

            <div class="container-fluid">
                <section-heading id="step-2"
                                 class="mb-3"
                                 :color="active_stage.color"
                                 sub-heading="Step 2"
                                 heading="Complete the stage activities with your team."
                                 image="/images/illustrations/writing.svg"></section-heading>
            </div>

            <div class="container-fluid activities-container">
                <div class="activities">
                    <div class="activities-row justify-content-center align-items-stretch">
                        <div v-for="item in 5" class="activities-item d-flex align-items-stretch">
                            <activity class="activity" :color="active_stage.color"></activity>
                        </div>
                    </div>
                </div>

                <div class="text-center mb-5">
                    <iconic-action-button :color="active_stage.color">
                        <template #icon><i class="dfcicon-arrow-up"></i></template>
                        Upload your work
                    </iconic-action-button>
                </div>

            </div>

        </div>
    </canvas-layout>
</template>

<script>
import CanvasLayout from "@/Layouts/CanvasLayout";
import CanvasHeader from "@/Components/StudentCanvas/CanvasHeader";
import StageTabs from "@/Components/StudentCanvas/StageTabs";
import StageTitle from "@/Components/StudentCanvas/StageTitle";
import StageHighlight from "@/Components/StudentCanvas/StageHighlight";
import GoToNextSection from "@/Components/StudentCanvas/GoToNextSection";
import SectionHeading from "@/Components/StudentCanvas/SectionHeading";
import Activity from "@/Components/StudentCanvas/Activity";
import IconicActionButton from "@/Components/Common/IconicActionButton";
export default {
    name: "StudentCanvas",
    components: {
        IconicActionButton,
        Activity,
        SectionHeading, GoToNextSection, StageHighlight, StageTitle, StageTabs, CanvasHeader, CanvasLayout},
    props: ['project', 'canvas', 'team'],

    data(){
        return {
            stage_id: 'warmup',
            stages: {
                warmup: {number: 1, name: 'Warmup', color: '#FA8728', title: 'Read the stage overview and watch the video.', icon: '/images/icons/icon-feel.webp', },
                feel: {number: 2, name: 'Feel', color: '#EF3B35', title: 'Read the stage overview and watch the video.', icon: '/images/icons/icon-feel.webp', },
                imagine: {number: 3, name: 'Imagine', color: '#FACA1A', title: 'Read the stage overview and watch the video.', icon: '/images/icons/icon-imagine.webp', },
                do: {number: 4, name: 'Do', color: '#3BB44A', title: 'Read the stage overview and watch the video.', icon: '/images/icons/icon-do.webp', },
                share: {number: 5, name: 'Share', color: '#1EBCEE', title: 'Read the stage overview and watch the video.', icon: '/images/icons/icon-share.webp', },
            },
        };
    },


    computed: {
        active_stage(){
            return this.stages[ this.stage_id ];
        }
    },


    methods: {
        tabChanged(tab){
            console.log({tabChanged: tab, stage: this.stages[tab]});
        }
    },

}
</script>

<style lang="scss" scoped>
.activity{
    width: 100%;
    flex: 0 0 100%;
}

.activities-container{
    padding-left: 1.4rem;
    padding-right: 1.4rem;
}

.activities-row{
    display: flex;
    flex-wrap: wrap;
    margin-left: 1.4rem;
    margin-right: 1.4rem;
}

.activities-item{
    padding-left: 1.4rem;
    padding-right: 1.4rem;
    width: 280px;
    flex: 0 0 280px;
    margin-bottom: 2.8rem;
}

</style>
